import React from 'react';
import { Redirect } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';

import { signIn } from 'modules/auth';
import Config from 'modules/config';
import IMAGES from 'modules/assets/web';
import queryString from 'query-string';

class SignInPage extends React.Component {
  state = {
    redirectToReferrer: false,
  };

  login = async values => {
    // signIn(values).then(() => this.setState({ redirectToReferrer: true }));
    const loginAttempt = await signIn(values);
    console.devLog.info('Loginattempt:', loginAttempt);
    return loginAttempt ? this.setState({ redirectToReferrer: true }) : null;
  };

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { redirectToReferrer } = this.state;
    const { email, setPassword, resetUrl } = queryString.parse(
      this.props.location.search,
      {
        ignoreQueryPrefix: true,
      },
    );

    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }
    const passwordResetLink =
      Config.ENV === 'production'
        ? 'https://www.nerdfitness.com/lostpassword/?coaching=true'
        : 'https://www.nerdfitness.com/lostpassword/?coaching=true';
    return (
      <div className="signin-wrapper col-xs-10 col-sm-8 col-md-6 col-lg-4 mx-auto">
        <Formik
          initialValues={{
            Email: email || '',
            Password: '',
          }}
          //  validationSchema={this.schema()}
          onSubmit={this.login}
          render={() => (
            <Form className="form-signin">
              <img
                className="mb-4 d-block mx-auto w-50"
                src={IMAGES.COACHING_1}
                alt=""
              />
              <h1 className="h3 mb-3 font-weight-normal">Please sign in</h1>
              {setPassword && (
                <div className="form-group">
                  <p className="text-primary font-italic">
                    Awesome! Your password is set! Now just use it below to sign
                    in.
                  </p>
                </div>
              )}
              {resetUrl && resetUrl.includes('resetpass') && (
                <div className="form-group">
                  <p className="text-primary font-italic">
                    Welcome! Your log in for Nerd Fitness Coaching is the same
                    as your NerdFitness.com account.
                  </p>
                  <p className="text-primary font-italic">
                    If you're not sure what your password is, you can use{' '}
                    <a
                      style={{ color: 'blue', textDecoration: 'underline' }}
                      href={resetUrl}
                      target="_blank"
                    >
                      this special link to go set your account password now
                    </a>
                    , or hit "Forgot Password" to trigger a password reset on
                    NerdFitness.com.
                  </p>
                  <p className="text-primary font-italic">
                    Make sure you come back here once you get your password set!
                  </p>
                </div>
              )}
              <div className="form-group">
                <label htmlFor="name">E-mail Address</label>
                <Field
                  type="email"
                  name="Email"
                  placeholder="Your E-mail"
                  className="form-control form-control-sm"
                />
              </div>
              <div className="form-group">
                <label htmlFor="name">Password</label>
                <Field
                  type="password"
                  name="Password"
                  placeholder="Password"
                  className="form-control form-control-sm"
                />
              </div>
              <div className="form-group">
                <p className="small" style={{ fontStyle: 'italic' }}>
                  Your NerdFitness.com login credentials
                </p>
              </div>
              <div className="form-group">
                <p>
                  <a target="_blank" href={passwordResetLink}>
                    Forgot Password?
                  </a>
                </p>
              </div>
              <button
                type="submit"
                className="btn btn-lg btn-primary btn-block"
              >
                Sign in
              </button>
            </Form>
          )}
        />
      </div>
    );
  }
}

export default SignInPage;

// https://getbootstrap.com/docs/4.0/examples/sign-in/
